import {useEffect, useRef, useState} from "react"

export const DEBOUNCE_MS = 300

export const useDebounceTime = (value, onValueChange, ignoreEmptyValues = true) => {
    const [localValue, setLocalValue] = useState(value)
    const onValueChangeRef = useRef(onValueChange)
    onValueChangeRef.current = onValueChange
    const lastSentRef = useRef(value)

    useEffect(() => {
        if (value !== lastSentRef.current) {
            setLocalValue(value)
            lastSentRef.current = value
        }
    }, [value])

    useEffect(() => {
        if (localValue === lastSentRef.current) {
            return
        }
        if (ignoreEmptyValues && localValue === value) {
            return
        }

        const handler = setTimeout(() => {
            lastSentRef.current = localValue
            onValueChangeRef.current(localValue)
        }, DEBOUNCE_MS)

        return () => clearTimeout(handler)
    }, [localValue])

    return {localValue, setLocalValue}
}
